module.exports = __webpack_public_path__ + "img/zm.c7ae1fe5.svg";